import { Route } from 'react-router-dom';

import { CancellationPolicyDetailPage } from './pages/cancellation-policy-detail-page.js';
import { CancellationPolicyFormPage } from './pages/cancellation-policy-form-page.js';
import { CancellationPolicyListPage } from './pages/cancellation-policy-list-page.js';

/**
 * The module's routes, owned by the module.
 *
 * Returned as a fragment of `<Route>` elements so the app's router composes
 * modules rather than enumerating every screen in one file.
 */
export function cancellationPolicyRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/cancellation-policies" element={<CancellationPolicyListPage />} />
      {/* Before the parameterised detail route: react-router ranks a static
          segment above a dynamic one, but keeping them in this order means a
          reader does not have to know that to see which wins. */}
      <Route path="/cancellation-policies/new" element={<CancellationPolicyFormPage />} />
      <Route
        path="/cancellation-policies/:policyId/edit"
        element={<CancellationPolicyFormPage />}
      />
      <Route path="/cancellation-policies/:policyId" element={<CancellationPolicyDetailPage />} />
    </>
  );
}
